import StartHere from './startHere/Index'
import { General } from './walkthrough/General'
import { Publication } from './walkthrough/publication'
import { Save } from './walkthrough/Save'

const Personalization = () => {
	const path = window.location.pathname
	
	return (
		<>
			<General/>
			<Publication/>
			<Save/>
			{path !== '/psl/onboarding' && <StartHere />}
		</>
	)
}

export default Personalization